<div class="main-container">
    <div class="top-section">
        <div class="icon-title">
            <div class="icon">
                <mat-icon svgIcon="orderaccount"></mat-icon>
            </div>
            <h1 class="font-poppins">{{ "order.heading.yourOrder" | translate }}</h1>
        </div>
        <p>{{ "Track and manage your toy orders" }}</p>
    </div>

    <div class="bottom-section" *ngIf="orders.length; else noOrders">
        <div class="spinner-container">
            <mat-spinner *ngIf="loading" class="loading-spinner" [diameter]="70"></mat-spinner>
        </div>
        @for (order of orders;let i = $index; track i) {
        <div class="order-section">
            <div class="order-items-middle">
                <!-- Only 3 items will be shown -->
                
                <div class="order-item-left">
                    <div class="image-container" [class.overlap]="(order.orderItems?.length ?? 0) > 1">
                        <div class="images">
                            @for (item of order.orderItems?.slice(0,2); track $index) {
                                <img class="order-image" [class]="'product-image-gradient' + ((i % 3) + 1)"
                                    [src]="item.product?.images?.imagesUrl?.[0]" (click)="onClickProduct(item.productId)" />
                            }
                        </div>

                        <div class="order-image images-more" *ngIf="(order.orderItems?.length ?? 0) > 2">
                            + {{(order.orderItems?.length ?? 0) - 2 }}
                        </div>
                    </div>
                    

                    <div class="item-detail">
                        @if ((order.orderItems?.length ?? 0) === 1) {
                            <p class="product-name font-poppins" appEllipsis="80%">
                                {{ order.orderItems?.[0]?.product?.name }}
                            </p>
                            <span *ngIf="order.orderItems?.[0]?.product?.modelQuantityJson">
                                ({{ order.orderItems?.[0]?.product?.modelQuantityJson?.totalBlock }}
                                {{ "order.orderDetails.shape" | translate }})
                            </span>
                        } @else {
                            <p class="product-name font-poppins">{{ order.orderItems?.length }} Items</p>
                        }
                            <p>{{ order.orderStatus }} on {{ order.updatedAt | date: "dd MMM YYY" }}</p>
                            <span> Order Placed on {{order.createdAt | date: "dd MM YYY"}}</span>
                    </div>
                </div>

                <div class="order-item-right">
                    <div class="status" [ngClass]="{
                        'status-deliver': order.orderStatus === orderStatus.Delivered,
                        'status-cancel': order.orderStatus === orderStatus.Failed || order.orderStatus === orderStatus.Cancelled
                        }">
                        <span>{{ order.orderStatus }}</span>
                    </div>

                    <p class="font-poppins"> ₹ {{ order.originalTotal | number:'1.0-0' }}</p>
                </div>
            </div>
            <div class="btn-section-bottom">
                <div class="btn-section">
                    <button mat-flat-button class="btn-tertiary-gradient" *ngIf="!isAbleToReview(order)"
                        (click)="navigateReviewPage(order.id)">Write Review</button>
                </div>

                <div class="btn-section">

                    @if(isItemOrderedOrPackedExist(order)){
                    <button mat-flat-button class="btn-secondary-gradient" (click)="navigateItemList(order, 'cancel')">
                        Cancel Order
                    </button>
                    }

                    <button mat-flat-button class="btn-primary-gradient" (click)="navigateOrderPage(order.id)">
                        View Order
                    </button>

                </div>


            </div>

        </div>
        }
  </div>

  <ng-template #noOrders>
    <div class="no-orders-card" *ngIf="!loading">
      <div class="no-orders-container">
        <!-- icon -->
        <div class="icon-wrapper">
          <mat-icon [svgIcon]="'noOrder'" class="icon1"></mat-icon>
          <mat-icon [svgIcon]="'search'" class="icon2"></mat-icon>
        </div>
        <h2 class="font-poppins">NO ORDER FOUND</h2>
        <div class="msg">
          <p>Looks like you haven't made your order yet.</p>
          <p>Start exploring fun Funfigz toys for your little one!</p>
        </div>

        <button class="btn" (click)="goBackToProducts()">
          <mat-icon svgIcon="arrowleft"></mat-icon> Back to Products
        </button>
      </div>
    </div>
    <div class="no-order-bottom">
      <div class="common" (click)="goToBestSeller()">
        <div class="contents">
          <div class="icon popular">
            <mat-icon [svgIcon]="'fullstar'"></mat-icon>
          </div>
          <div class="para">
            <p class="font-poppins">Popular Toys</p>
            <span>Discover trending toys for kids</span>
          </div>
        </div>
      </div>
      <div class="common" (click)="goToFeature()">
        <div class="contents">
          <div class="icon offer">
            <mat-icon svgIcon="offer"></mat-icon>
          </div>
          <div class="para">
            <p class="font-poppins">Special Offers</p>
            <span>Check out amazing deals</span>
          </div>
        </div>
      </div>
      <div class="common" (click)="goToWishlist()">
        <div class="contents">
          <div class="icon wish">
            <mat-icon svgIcon="activewishlist"></mat-icon>
          </div>
          <div class="para">
            <p class="font-poppins">Wishlist</p>
            <span>Save toys for later</span>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <div class="my-custom-paginator" *ngIf="totalOrders > pageSize">
    <div class="left">
      Showing <span>{{ itemPerPage }}</span> of
      <span>{{ totalOrders }}</span> orders
    </div>

    <div class="right">
      <button
        class="btn"
        (click)="goToPreviousPage()"
        [disabled]="currentPageIndex === 0"
      >
        <mat-icon svgIcon="backarrow"></mat-icon> Previous
      </button>
      <button
        class="btn"
        (click)="goToNextPage()"
        [disabled]="(currentPageIndex + 1) * pageSize >= totalOrders"
      >
        Next <mat-icon svgIcon="forwardarrow"></mat-icon>
      </button>
    </div>
  </div>
</div>
